import { combineReducers } from "redux";

import userReducer from "../user";
import metadataReducer from "../metadata";
import principalReducer from "../principal";
import skuMappingReducer from "../skuMapping";
import offeringsReducer from "../offerings";
import subscriptionsReducer from "../subscriptions";
import StandingReducer from "../standing";
import businessSettingsReducer from "../businessSettings";
import ManageUsersReduser from "../manageUsers";
import accountReducer from "../account";
import usageReducer from "../usage";
import billingHistoryReducer from "../billingHistory";
import renewalInvoiceReducer from "../renewalInvoice";

export * from "./types";

const reducers = combineReducers({
  user: userReducer,
  metadata: metadataReducer,
  principal: principalReducer,
  skuMapping: skuMappingReducer,
  offerings: offeringsReducer,
  subscriptions: subscriptionsReducer,
  standing: StandingReducer,
  businessSettings: businessSettingsReducer,
  manageUsers: ManageUsersReduser,
  account: accountReducer,
  usage: usageReducer,
  billingHistory: billingHistoryReducer,
  renewalInvoice: renewalInvoiceReducer,
});

export default reducers;
